<template>
  <BasePopup ref="popup" title="Disable the integration?" class="popup--simple">
    <div>
      <p>
        Are you sure you want to disable the {{ integrationName }} integration?
      </p>
      <form class="cancel-form">
        <div class="cancel-form__group--submit">
          <a
            class="cancel-form__close-btn btns btns--largest btns--font-large btns--full"
            @click="hide"
            >No</a
          >
          <a
            v-wait:disabled="'Canceling'"
            class="cancel-form__btn btns btns--largest btns--font-large btns--white btns--full"
            @click="disable"
          >
            <v-wait for="Disabling">
              <template v-slot:waiting>
                Disabling
                <button-spinner />
              </template>
              <span>Disable</span>
            </v-wait>
          </a>
        </div>
      </form>
    </div>
  </BasePopup>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useWait } from '@/app/composables/useWait'

import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import BasePopup from '@/components/ui/BasePopup.vue'

const props = defineProps<{
  disableIntegration: () => Promise<void>
  integrationName: string
  afterDisableCallback: any
}>()

const emit = defineEmits<{
  (e: 'updateEnabled', value: boolean): void
}>()
const wait = useWait()

const popup = ref<InstanceType<typeof BasePopup> | null>(null)

function show(): void {
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

async function disable(): Promise<void> {
  wait.start('Disabling')
  await props.disableIntegration()
  if (props.afterDisableCallback) {
    await props.afterDisableCallback()
  }
  wait.end('Disabling')
  emit('updateEnabled', false)
  hide()
}

defineExpose({
  show,
  hide,
})
</script>
